import React, { useEffect, useState } from 'react';
import api from '../api';

function Reports() {
  const [report,   setReport]   = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [activeTab, setActiveTab] = useState('today');

  useEffect(() => {
    // Try /reports/ first, fallback to /alerts/daily-report + /alerts/low-stock
    api.get('/reports/')
      .then(res => { setReport(res.data); setLoading(false); })
      .catch(() => {
        // Fallback: old routes
        Promise.all([
          api.get('/alerts/daily-report'),
          api.get('/alerts/low-stock'),
        ]).then(([repRes, lowRes]) => {
          const r = repRes.data;
          const l = lowRes.data;
          setReport({
            plan: 'pro', is_premium: false,
            today_revenue: r.total_revenue || 0,
            today_bills: r.total_bills || 0,
            month_revenue: r.total_revenue || 0,
            month_bills: r.total_bills || 0,
            last_month_revenue: 0,
            total_bills: r.total_bills || 0,
            total_revenue: r.total_revenue || 0,
            total_items: 0,
            low_stock_count: r.low_stock_count || l.count || 0,
            low_stock_items: l.items || [],
            recent_bills: [],
            top_items: [],
            mrp_saving: null,
            report_message: r.report_message || '',
          });
          setLoading(false);
        }).catch(() => setLoading(false));
      });
  }, []);

  const sendWhatsApp = (msg) =>
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');

  if (loading) return (
    <div style={{ textAlign:'center', padding:'60px', fontSize:'18px', color:'#666' }}>
      ⏳ ஏற்றுகிறது...
    </div>
  );

  if (!report) return (
    <div style={{ textAlign:'center', padding:'60px', color:'#e74c3c' }}>
      ❌ Report load ஆகவில்லை. Refresh பண்ணுங்கள்.
    </div>
  );

  const isPremium = report.is_premium;

  // Month-over-month growth
  const growth = report.last_month_revenue > 0
    ? (((report.month_revenue - report.last_month_revenue) / report.last_month_revenue) * 100).toFixed(1)
    : null;

  return (
    <div style={s.page}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px' }}>
        <h1 style={s.title}>📈 அறிக்கைகள்</h1>
        {isPremium && (
          <span style={{ background:'#C9A84C', color:'white', padding:'4px 14px', borderRadius:'20px', fontSize:'12px', fontWeight:'700' }}>
            👑 Premium
          </span>
        )}
      </div>

      {/* ── TABS ── */}
      <div style={s.tabs}>
        {[
          { id:'today',   label:'📊 இன்று' },
          { id:'month',   label:'📅 இந்த மாதம்' },
          { id:'stock',   label:`⚠️ குறைந்த சரக்கு${report.low_stock_count > 0 ? ` (${report.low_stock_count})` : ''}` },
          { id:'top',     label:'🏆 அதிக விற்பனை' },
          { id:'recent',  label:'🧾 சமீபத்திய பில்கள்' },
        ].map(t => (
          <button key={t.id}
            style={{ ...s.tab, ...(activeTab === t.id ? s.tabActive : {}) }}
            onClick={() => setActiveTab(t.id)}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ══════════════════════════════════
          TAB: TODAY
      ══════════════════════════════════ */}
      {activeTab === 'today' && (
        <div>
          <div style={s.dateBox}>
            📅 {new Date().toLocaleDateString('ta-IN', { weekday:'long', year:'numeric', month:'long', day:'numeric' })}
          </div>

          <div style={s.statsRow}>
            <StatCard icon="💰" value={`₹${report.today_revenue.toFixed(2)}`} label="இன்றைய வருவாய்" color="#27ae60" />
            <StatCard icon="🧾" value={report.today_bills}                    label="இன்றைய பில்கள்" color="#3498db" />
            <StatCard icon="⚠️" value={report.low_stock_count}                label="குறைந்த சரக்கு"  color="#e74c3c" />
          </div>

          {/* MRP Saving — Premium only */}
          {isPremium && report.mrp_saving > 0 && (
            <div style={{
              background:'linear-gradient(135deg,#27ae60,#2ecc71)',
              borderRadius:'12px', padding:'20px',
              color:'white', marginBottom:'20px',
              display:'flex', justifyContent:'space-between', alignItems:'center',
            }}>
              <div>
                <div style={{ fontSize:'13px', opacity:0.9, marginBottom:'4px' }}>🏷️ இந்த மாதம் Customer-களுக்கு TODAY SAVING</div>
                <div style={{ fontSize:'28px', fontWeight:'900' }}>₹{report.mrp_saving.toFixed(2)}</div>
                <div style={{ fontSize:'11px', opacity:0.8, marginTop:'4px' }}>MRP vs Selling Price difference</div>
              </div>
              <div style={{ fontSize:'48px' }}>🎉</div>
            </div>
          )}

          {/* All-time summary */}
          <div style={{ ...s.card, marginBottom:'20px' }}>
            <h3 style={s.cardTitle}>📊 மொத்த சுருக்கம்</h3>
            <div style={s.summaryGrid}>
              <SummaryRow label="மொத்த பில்கள்"     value={report.total_bills} />
              <SummaryRow label="மொத்த வருவாய்"     value={`₹${report.total_revenue.toFixed(2)}`} />
              <SummaryRow label="மொத்த பொருட்கள்"     value={report.total_items} />
              <SummaryRow label="குறைந்த சரக்கு"     value={report.low_stock_count} color="#e74c3c" />
            </div>
          </div>

          {/* WhatsApp */}
          <div style={s.waSection}>
            <h3 style={{ color:'#2c3e50', marginBottom:'12px' }}>📱 WhatsApp Report அனுப்பு</h3>
            <div style={s.preview}>{report.report_message}</div>
            <button style={s.waBtn} onClick={() => sendWhatsApp(report.report_message)}>
              📱 அனுப்பு
            </button>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════
          TAB: THIS MONTH
      ══════════════════════════════════ */}
      {activeTab === 'month' && (
        <div>
          <div style={s.statsRow}>
            <StatCard icon="💰" value={`₹${report.month_revenue.toFixed(2)}`} label="இந்த மாதம் வருவாய்"  color="#27ae60" />
            <StatCard icon="🧾" value={report.month_bills}                     label="இந்த மாதம் பில்கள்"  color="#3498db" />
            <StatCard icon="📅" value={`₹${report.last_month_revenue.toFixed(2)}`} label="கடந்த மாதம்"    color="#9b59b6" />
          </div>

          {growth !== null && (
            <div style={{
              background: parseFloat(growth) >= 0 ? '#e8f8f0' : '#fff0f0',
              border: `1px solid ${parseFloat(growth) >= 0 ? '#27ae60' : '#e74c3c'}`,
              borderRadius:'10px', padding:'14px 18px', marginBottom:'20px',
              fontSize:'15px', fontWeight:'700',
              color: parseFloat(growth) >= 0 ? '#27ae60' : '#e74c3c',
            }}>
              {parseFloat(growth) >= 0 ? '📈' : '📉'} கடந்த மாதத்தை விட {Math.abs(growth)}% {parseFloat(growth) >= 0 ? 'அதிகம்' : 'குறைவு'}
            </div>
          )}

          {/* Premium MRP saving */}
          {isPremium && report.mrp_saving !== null && (
            <div style={{ ...s.card, marginBottom:'20px', borderLeft:'4px solid #C9A84C' }}>
              <h3 style={s.cardTitle}>🏷️ Customer TODAY SAVING (இந்த மாதம்)</h3>
              <div style={{ fontSize:'32px', fontWeight:'900', color:'#27ae60' }}>
                ₹{report.mrp_saving.toFixed(2)}
              </div>
              <div style={{ fontSize:'13px', color:'#888', marginTop:'4px' }}>
                MRP விலையில் இருந்து selling price கழித்த customer savings
              </div>
            </div>
          )}

          {!isPremium && (
            <div style={{
              background:'#FFF9E6', border:'1px solid #C9A84C',
              borderRadius:'10px', padding:'14px 18px', marginBottom:'20px',
              fontSize:'13px', color:'#856404',
            }}>
              👑 MRP vs Selling Price saving report — Premium / Business plan-ல் மட்டும் கிடைக்கும்!
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════════
          TAB: LOW STOCK
      ══════════════════════════════════ */}
      {activeTab === 'stock' && (
        <div>
          {report.low_stock_count === 0 ? (
            <div style={{ textAlign:'center', padding:'60px', color:'#27ae60' }}>
              <div style={{ fontSize:'64px' }}>✅</div>
              <h3>அனைத்து சரக்குகளும் போதுமான அளவில் உள்ளன!</h3>
            </div>
          ) : (
            <>
              <div style={{ ...s.card, marginBottom:'20px' }}>
                <table style={s.table}>
                  <thead>
                    <tr style={s.thead}>
                      <th style={s.th}>பொருள்</th>
                      <th style={s.th}>இருப்பு</th>
                      <th style={s.th}>Alert நிலை</th>
                      <th style={s.th}>நிலை</th>
                    </tr>
                  </thead>
                  <tbody>
                    {report.low_stock_items.map((item, i) => (
                      <tr key={item.id} style={{ backgroundColor: i%2===0 ? 'white' : '#fff8f0' }}>
                        <td style={s.td}>
                          <strong>{item.name}</strong>
                          {item.name_tamil && <div style={{ fontSize:'11px', color:'#999' }}>{item.name_tamil}</div>}
                        </td>
                        <td style={{ ...s.td, color:'#e74c3c', fontWeight:'700' }}>{item.quantity}</td>
                        <td style={s.td}>{item.low_stock_alert}</td>
                        <td style={s.td}>
                          <span style={{ background:'#fde8e8', color:'#e74c3c', padding:'3px 8px', borderRadius:'12px', fontSize:'12px', fontWeight:'700' }}>
                            ⚠️ குறைவு
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={s.waSection}>
                <h3 style={{ color:'#2c3e50', marginBottom:'12px' }}>📱 Supplier-க்கு அனுப்பு</h3>
                <button style={{ ...s.waBtn, background:'#e74c3c' }}
                  onClick={() => {
                    const msg = `⚠️ *குறைந்த சரக்கு*\n━━━━━━━━━━━━━━━\n${report.low_stock_items.map(i=>`📦 ${i.name_tamil||i.name}: ${i.quantity} மட்டும்`).join('\n')}\n━━━━━━━━━━━━━━━\nJSMSTOCK.COM`;
                    sendWhatsApp(msg);
                  }}>
                  📱 Supplier-க்கு எச்சரிக்கை அனுப்பு
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* ══════════════════════════════════
          TAB: TOP ITEMS
      ══════════════════════════════════ */}
      {activeTab === 'top' && (
        <div>
          <div style={{ fontSize:'13px', color:'#888', marginBottom:'14px' }}>
            இந்த மாதம் அதிகமாக விற்பனை ஆன பொருட்கள்:
          </div>
          {report.top_items.length === 0 ? (
            <div style={{ textAlign:'center', padding:'40px', color:'#999' }}>
              இந்த மாதம் இன்னும் bills இல்லை
            </div>
          ) : (
            <div style={s.card}>
              <table style={s.table}>
                <thead>
                  <tr style={s.thead}>
                    <th style={s.th}>வரிசை</th>
                    <th style={s.th}>பொருளின் பெயர்</th>
                    <th style={s.th}>விற்ற அளவு</th>
                    <th style={s.th}>மொத்த வருவாய்</th>
                  </tr>
                </thead>
                <tbody>
                  {report.top_items.map((item, i) => (
                    <tr key={i} style={{ backgroundColor: i%2===0 ? 'white' : '#f8f9fa' }}>
                      <td style={s.td}>
                        <span style={{
                          background: i===0?'#C9A84C':i===1?'#95a5a6':i===2?'#cd7f32':'#eee',
                          color: i<3?'white':'#666',
                          width:'24px', height:'24px', borderRadius:'50%',
                          display:'inline-flex', alignItems:'center', justifyContent:'center',
                          fontSize:'12px', fontWeight:'700',
                        }}>{i+1}</span>
                      </td>
                      <td style={s.td}>
                        <strong>{item.name_tamil || item.name}</strong>
                        {item.name_tamil && <div style={{ fontSize:'11px', color:'#999' }}>{item.name}</div>}
                      </td>
                      <td style={s.td}>{Number(item.total_qty) % 1 === 0 ? item.total_qty : Number(item.total_qty).toFixed(2)}</td>
                      <td style={{ ...s.td, fontWeight:'700', color:'#27ae60' }}>₹{item.total_amount.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════════
          TAB: RECENT BILLS
      ══════════════════════════════════ */}
      {activeTab === 'recent' && (
        <div style={s.card}>
          <table style={s.table}>
            <thead>
              <tr style={s.thead}>
                <th style={s.th}>பில் எண்</th>
                <th style={s.th}>வாடிக்கையாளர்</th>
                <th style={s.th}>தொகை</th>
                <th style={s.th}>தேதி</th>
              </tr>
            </thead>
            <tbody>
              {report.recent_bills.length === 0 ? (
                <tr><td colSpan={4} style={{ textAlign:'center', padding:'30px', color:'#999' }}>Bills இல்லை</td></tr>
              ) : (
                report.recent_bills.map((b, i) => (
                  <tr key={b.id} style={{ backgroundColor: i%2===0 ? 'white' : '#f8f9fa' }}>
                    <td style={s.td}><strong>#{b.bill_number}</strong></td>
                    <td style={s.td}>{b.customer_name}</td>
                    <td style={{ ...s.td, fontWeight:'700', color:'#27ae60' }}>₹{b.total_amount.toFixed(2)}</td>
                    <td style={s.td}>{new Date(b.created_at).toLocaleDateString('ta-IN')}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── Small reusable components ──
function StatCard({ icon, value, label, color }) {
  return (
    <div style={{ background:'white', borderRadius:'12px', padding:'20px', textAlign:'center', boxShadow:'0 2px 10px rgba(0,0,0,0.06)', border:'1px solid #eee', borderTop:`4px solid ${color}` }}>
      <div style={{ fontSize:'28px', marginBottom:'8px' }}>{icon}</div>
      <div style={{ fontSize:'28px', fontWeight:'900', color, marginBottom:'4px' }}>{value}</div>
      <div style={{ fontSize:'13px', color:'#888' }}>{label}</div>
    </div>
  );
}

function SummaryRow({ label, value, color='#2c3e50' }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #f0f0f0', fontSize:'14px' }}>
      <span style={{ color:'#666' }}>{label}</span>
      <span style={{ fontWeight:'700', color }}>{value}</span>
    </div>
  );
}

const s = {
  page:      { padding:'20px', maxWidth:'960px', margin:'0 auto' },
  title:     { color:'#2c3e50', marginBottom:0 },
  tabs:      { display:'flex', gap:'8px', marginBottom:'24px', flexWrap:'wrap' },
  tab:       { padding:'9px 16px', border:'2px solid #ddd', borderRadius:'8px', cursor:'pointer', background:'white', fontWeight:'600', fontSize:'13px', color:'#666' },
  tabActive: { borderColor:'#2c3e50', background:'#2c3e50', color:'white' },
  dateBox:   { background:'#f0f4ff', border:'1px solid #dce4ff', padding:'12px 16px', borderRadius:'8px', marginBottom:'20px', fontSize:'14px', color:'#2c3e50', fontWeight:'600' },
  statsRow:  { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px', marginBottom:'20px' },
  card:      { background:'white', borderRadius:'12px', padding:'20px', border:'1px solid #eee', marginBottom:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.04)' },
  cardTitle: { color:'#2c3e50', marginBottom:'14px', fontSize:'15px' },
  summaryGrid: { display:'flex', flexDirection:'column', gap:'0' },
  waSection: { background:'#f9f9f9', border:'1px solid #eee', borderRadius:'12px', padding:'20px' },
  preview:   { background:'white', border:'1px solid #ddd', borderRadius:'8px', padding:'14px', fontFamily:'monospace', fontSize:'13px', whiteSpace:'pre-wrap', color:'#333', marginBottom:'14px', lineHeight:'1.6' },
  waBtn:     { background:'#25D366', color:'white', border:'none', padding:'12px 24px', borderRadius:'8px', cursor:'pointer', fontWeight:'700', fontSize:'15px', width:'100%' },
  table:     { width:'100%', borderCollapse:'collapse' },
  thead:     { background:'#2c3e50' },
  th:        { padding:'12px 16px', color:'white', fontSize:'13px', fontWeight:'600', textAlign:'left' },
  td:        { padding:'12px 16px', borderBottom:'1px solid #f0f0f0', fontSize:'14px' },
};

export default Reports;

